<template>
  <div class="player-bg">
    <div class="player-box">
      <div class="close-box" @click.stop="close()">
        <img
          src="../../assets/images/create-college/close-icon.png"
          alt=""
          class="close-icon"
        />
      </div>
      <div class="prism-player" id="player-con"></div>
    </div>
  </div>
</template>

<script>
import api from "../../assets/js/api";
export default {
  name: "ShopCenterAdminWebVideoPlayer",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    videoInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      videoUrl: "",
      videoPlayer: null,
      timer: null,
      playTimer: 0,
      startTime: "",
      playerParams: {
        id: "player-con",
        source: "",
        width: "100%",
        height: "600px",
        autoplay: false,
        isLive: false,
        rePlay: false,
        playsinline: true,
        preload: true,
        controlBarVisibility: "hover",
        useH5Prism: true,
        // 倍速播放组件
        // components: [
        //   {
        //     name: "RateComponent",
        //     // 解决报错
        //     // eslint-disable-next-line no-undef
        //     type: AliPlayerComponent.RateComponent,
        //   },
        // ],
        skinLayout: [
          {
            name: "bigPlayButton",
            align: "blabs",
            x: 30,
            y: 80,
          },
          {
            name: "H5Loading",
            align: "cc",
          },
          {
            name: "errorDisplay",
            align: "tlabs",
            x: 0,
            y: 0,
          },
          {
            name: "infoDisplay",
          },
          {
            name: "tooltip",
            align: "blabs",
            x: 0,
            y: 56,
          },
          {
            name: "thumbnail",
          },
          {
            name: "controlBar",
            align: "blabs",
            x: 0,
            y: 0,
            children: [
              {
                name: "progress",
                align: "blabs",
                x: 0,
                y: 44,
              },
              {
                name: "playButton",
                align: "tl",
                x: 15,
                y: 12,
              },
              {
                name: "timeDisplay",
                align: "tl",
                x: 10,
                y: 7,
              },
              {
                name: "fullScreenButton",
                align: "tr",
                x: 10,
                y: 12,
              },
              {
                name: "volume",
                align: "tr",
                x: 5,
                y: 10,
              },
            ],
          },
        ],
      },
    };
  },

  async mounted() {
    await this.getCourseInfo();
    // 初始化阿里云播放器
    this.playerParams.source = this.videoUrl;
    // 解决报错
    // eslint-disable-next-line no-undef
    this.videoPlayer = new Aliplayer(this.playerParams, function (player) {
      console.log("The player is created---", player);
    });
    // 绑定播放器相关处理事件
    this.videoPlayer.on("play", this.playHandler);
    this.videoPlayer.on("pause", this.pauseHandler);
    this.videoPlayer.on("ended", this.endedHandler);
    // 绑定浏览器页面关闭事件
    window.addEventListener("beforeunload", await this.beforeunloadHandler);
  },

  methods: {
    async getCourseInfo() {
      const res = await this.$axios.post(api.creatCollege.getCourseVideo, {
        mediaId: this.videoInfo.mediaId,
      });
      // console.log("获取的课程信息---", res);
      if (res.valid) {
        this.videoUrl = res.result.url;
      }
    },
    // 上报学习记录
    async uploadRecords() {
      // 判断用户是否有播放 没有播放 就不上报
      if (!this.startTime) return;
      // 判断播放时长是否大于3秒 小于3秒不上报
      if (this.playTimer < 3) return;
      // 上报学习记录
      await this.$axios.post(api.creatCollege.uploadRecords, {
        lessonId: this.videoInfo.id || this.videoInfo.lessonId,
        playDurationSeconds: this.playTimer,
        startTime: this.startTime,
      });
      // console.log("上报学习记录res---", res);
    },
    async close() {
      // 销毁计数器
      clearInterval(this.timer);
      // 销毁播放器
      this.videoPlayer.dispose();
      // 销毁window绑定事件
      window.removeEventListener("beforeunload", this.beforeunloadHandler);
      // 上报记录
      await this.uploadRecords();
      // 关闭弹窗
      this.$emit("closePlayer");
    },
    playHandler() {
      // 获取视频初次开始播放时的北京时间时间戳
      if (!this.startTime) {
        this.startTime = new Date();
      }
      this.timer = setInterval(() => {
        if (this.playTimer >= this.videoPlayer.getDuration()) {
          clearInterval(this.timer);
          return;
        }
        this.playTimer++;
      }, 1000);
    },
    pauseHandler() {
      clearInterval(this.timer);
    },
    endedHandler() {
      clearInterval(this.timer);
    },
    async beforeunloadHandler() {
      // 执行上报操作
      await this.uploadRecords();
    },
  },
};
</script>

<style lang="scss" scoped>
.player-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  z-index: 999999;
  background: rgba(0, 0, 0, 0.6);
  .player-box {
    position: relative;
    width: 1000px;
    height: 600px;
    border-radius: 8px;
    // background: #ccc;
    .close-box {
      position: absolute;
      top: 0px;
      right: -32px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 22px;
      height: 22px;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      cursor: pointer;
      & > img {
        width: 12px;
        height: 12px;
      }
    }
    .prism-player {
      border-radius: 8px;
      overflow: hidden;
    }
  }
}
</style>
